import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 32px",
    },
    headerTitle: {
        fontSize: "18px",
        fontFamily: "Source Sans 3",
        color: theme.palette.info.main,
    },
    headerActions: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    closeIcon: {
        cursor: "pointer",
    },
    footerDivider: {
        width: "100%",
    },
    footer: {
        display: "flex",
        justifyContent: "flex-end",
        padding: "24px 32px",
        gap: "16px",
    },
    button: {
        "&.MuiButton-root": {
            fontFamily: "Source Sans 3 !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
            color: `${theme.palette.primary.dark} !important`,
        },
    },
    okButton: {
        "&.MuiButton-root": {
            fontFamily: "Source Sans 3 !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
}));

export const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "792px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "4px",
};
